import { Add, Close, Delete, Email, Folder, Person, Phone, Place, Save, Web, WhatsApp } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CardHeader, Divider, Grid, IconButton, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const FuncionesTab = ({ datos, imagenes, editable, setData, handleUpdate }) => {
    const handleInputChange = (e, index, type) => {
        let newArr = datos.map((actividad, i) => {
            if (i == index) {
                return { ...actividad, [type]: e.target.value }
            }
            else {
                return actividad

            }
        });
        setData({ target: { value: newArr } });
    }

    const handleRemoveActividad = (index) => {
        let newArr = datos.filter((el, i) => i !== index);
        setData({ target: { value: newArr } });
    }

    const handleAddActividad = () => {
        setData({
            target: {
                value: [...datos, {
                    actividad_proceso: '',
                    cant_empresas: '',
                    cant_socios: ''
                }]
            }
        })
    }

    const handleInput = (e, index) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'funciones_servicios';
                imagen.index = index;
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                });
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }
    if (datos) {
        return (
            <Box sx={{ m: 2 }}>
                <Box sx={{ my: 2 }}>
                    <Typography sx={{ mb: 2 }} variant="h6">Actividades y procesos de producción</Typography>
                    {editable ?
                        <Stack direction='column' spacing={1}>
                            {
                                datos.map((actividad, indexAct) => {
                                    // console.log(actividad);
                                    return (
                                        <Box key={indexAct} sx={{ mb: 4, p: 2, border: 1, borderColor: '#e0dcda', borderRadius: 2 }}>
                                            <Typography variant="h6">Actividad o Proceso {indexAct + 1}</Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                label="Descripción de la actividad o proceso"
                                                defaultValue={actividad.actividad_proceso}
                                                name="actividad_proceso"
                                                value={actividad.actividad_proceso}
                                                inputProps={{ maxLength: 100 }}
                                                onChange={(e) => handleInputChange(e, indexAct, 'actividad_proceso')}
                                            />
                                            <Stack direction="row" spacing={2}>
                                                <TextField
                                                    fullWidth
                                                    label="# de empresas y/u organizaciones atendidas"
                                                    type="number"
                                                    name="cant_empresas"
                                                    defaultValue={actividad.cant_empresas}
                                                    value={actividad.cant_empresas}
                                                    onChange={(e) => handleInputChange(e, indexAct, 'cant_empresas')}
                                                />
                                                <TextField
                                                    fullWidth
                                                    label="# socios atendidos"
                                                    type="number"
                                                    name="cant_socios"
                                                    defaultValue={actividad.cant_socios}
                                                    value={actividad.cant_socios}
                                                    onChange={(e) => handleInputChange(e, indexAct, 'cant_socios')}
                                                />
                                            </Stack>
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="h6">Fotogalería de la actividad o proceso {indexAct + 1} (máximo 2 fotos)</Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                    {Object.values(imagenes)
                                                        .filter((i) => i.paso === 'funciones_servicios' && indexAct == i.indice)
                                                        .map((image, index) => (
                                                            <Box key={image.name ?? index} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1 }}>
                                                                <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                                                    <Close />
                                                                </IconButton>
                                                                <img src={image.url_img ?? image.dataurl} alt={image.name ?? ''} width="150px" />
                                                            </Box>
                                                        ))}
                                                </Box>
                                                <Button
                                                    disabled={Object.values(imagenes).filter((i) => i.paso === 'funciones_servicios' && indexAct == i.indice).length >= 2}
                                                    component="label"
                                                    variant="contained"
                                                    startIcon={<Folder />}
                                                >
                                                    Agregar Imagen
                                                    <input type="file" accept="image/*" hidden onChange={(e) => handleInput(e, indexAct)} />
                                                </Button>
                                            </Box>
                                            <Button sx={{ mt: 2 }} startIcon={<Delete />} color="error" onClick={() => handleRemoveActividad(indexAct)}>
                                                Eliminar Actividad
                                            </Button>
                                        </Box>
                                    )
                                })
                            }
                            <Button variant="contained" color="primary" onClick={handleAddActividad} startIcon={<Add />}>
                                Agregar Actividad
                            </Button>
                        </Stack>
                        :
                        <Box>
                            {datos.map((actividad, indexAct) => (
                                <Card sx={{ mb: 2 }}>
                                    <CardHeader title={
                                        <Typography variant="h6"><b>Actividad o proceso #{indexAct + 1}:</b> {actividad.actividad_proceso}</Typography>
                                    } />
                                    <CardContent>
                                        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                                            <Stack spacing={2}>
                                                <Typography fontWeight="bold">Cantidad de empresas:</Typography>
                                                <Typography>{actividad.cant_empresas}</Typography>
                                            </Stack>
                                            <Stack spacing={2}>
                                                <Typography fontWeight="bold">Cantidad de socios:</Typography>
                                                <Typography>{actividad.cant_socios}</Typography>
                                            </Stack>
                                        </Stack>
                                        {/* Imagenes de cada actividad */}
                                        <Typography fontWeight="bold" sx={{ my: 2 }}>Fotogalería:</Typography>
                                        <Grid container spacing={2}>
                                            {Object.values(imagenes)
                                                .filter((i) => i.paso === 'funciones_servicios' && indexAct == i.indice)
                                                .map((img, index) => {
                                                    return (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                            key={index}
                                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                                        >
                                                            <img
                                                                src={img.url_img ?? img.dataurl}
                                                                width="100%"
                                                                alt={index}
                                                                style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                            />
                                                        </Grid>
                                                    )
                                                })}

                                        </Grid>
                                    </CardContent>

                                </Card>
                            )
                            )}
                        </Box>
                    }
                </Box>

                <Divider />
                <Box>
                    <Typography sx={{ my: 2 }} variant="h6"></Typography>
                </Box>

                {/*//TODO agregar actividad */}

                {
                    editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }
            </Box >
        )
    }
}

export default FuncionesTab
